import { render } from "./IngresoPropioComponent.vue?vue&type=template&id=1795dc81&scoped=true"
import script from "./IngresoPropioComponent.vue?vue&type=script&lang=js"
export * from "./IngresoPropioComponent.vue?vue&type=script&lang=js"

import "./IngresoPropioComponent.vue?vue&type=style&index=0&id=1795dc81&scoped=true&lang=css"

import exportComponent from "/Users/luismanuel/Documents/www/tuxtlacomovamos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1795dc81"]])

export default __exports__